import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-extras-modal',
  templateUrl: './extras-modal.component.html',
  styleUrls: ['./extras-modal.component.scss']
})
export class ModalExtrasComponent {
  title: string = '';
  message: string = '';
  operationSuccess: boolean = true;

  constructor(public modalRef: BsModalRef, private router: Router, private translate: TranslateService
) {}

  closeModal(): void {
    this.modalRef.hide();
    this.router.navigate(['/overview']);
  }

  setModalData(success: boolean): void {
    this.operationSuccess = success;
    if (success) {
      this.title = this.translate.instant('EXTRAS_PAGE.MODAL_SUCCESS_TITLE');
      this.message = this.translate.instant('EXTRAS_PAGE.MODAL_SUCCESS_DESCRIPTION');
    } else {
      this.title = this.translate.instant('EXTRAS_PAGE.MODAL_FAILED_TITLE');
      this.message = this.translate.instant('EXTRAS_PAGE.MODAL_FAILED_DESCRIPTION');
    }
  }
}
